module.exports = "/_next/static/images/thumb_up-e33e0828efc2b93cba3ce5645384e80e.svg";